import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { Subject } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrManager } from "ng6-toastr-notifications";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UploadS3ObjectComponent } from "../upload-s3-object/upload-s3-object.component";
import { DatePipe } from '@angular/common';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Component({
  selector: "app-s3object",
  templateUrl: "./s3object.component.html",
  styleUrls: ["./s3object.component.css"]
})
export class S3objectComponent {
  public bucketName;
  public objectData;
  public bname = [];
  public submitted: boolean = false;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrManager,
    private modalService: NgbModal,
    private datePipe: DatePipe,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      rowCallback: (row: Node, data: Object, index: number) => {
        $("input[type='checkbox']", row).unbind("click");
        $("input[type='checkbox']", row).bind("click", () => {
          const index = this.bname.indexOf(data[2]);
          if ($("input[type='checkbox']", row).is(":checked")) {
            if (index === -1) {
              this.bname.push(data[2]);
              console.log(this.bname);
            }
          } else {
            this.bname.splice(index, 1);
            console.log(this.bname);
          }
          console.log(this.bname.length);
          if (this.bname.length > 1) {
            console.log(this.submitted)
            this.submitted = true;
          } else {
            this.submitted = false;
          }
        });

        return row;
      }
    };
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 2 seconds */
      this.spinner.hide();
    }, 2000);
    this.listS3Object();
  }

  listS3Object(): void {
    this.route.params.subscribe(params => {
      console.log(params);
      this.bucketName = params.bucketname;
      this.dataService.listS3Object(params).subscribe((Data: any) => {
        console.log(Data);
        if (Data.Status == "Error") {
          // alert(Data.Error.message);
          this.toastr.errorToastr("You are not authorized to view objects for this bucket.","oops!")
        } else {
          this.objectData = Data.Data.Contents;
          this.dtTrigger.next();
        }
      });
    });
  }

  getKey(key){
  //  console.log(key.substring(key.lastIndexOf("/") + 1))
   if(key.lastIndexOf("/")> 0){
     return key.substring(key.lastIndexOf("/") + 1)
   }else {
     return key
   }
  }

  getDate( date){
    // console.log(this.datePipe.transform('2018-10-05T07:54:18.881Z'	, 'medium'));
    // console.log(date)
    return this.datePipe.transform(date, 'medium')
  }

  getSize(size){
    // console.log(typeof size)
    return (size/(1048576)).toFixed(2) 
  }

  deleteSingleS3Object(key) {
    this.bname=[]
    if(this.bname.length == 0){
    this.bname.push(key);
    }
    if(this.bname.length == 1){
      this.deleteS3Object();
    }
  }

  deleteS3Object() {
    console.log(this.bname);

    let s3DeleteData = { Objects: [] };
    s3DeleteData["bucketName"] = this.bucketName;
    for (let i = 0; i < this.bname.length; i++) {
      s3DeleteData.Objects.push({ Key: this.bname[i] });
    }
    s3DeleteData["region"] = localStorage.getItem("region");
    console.log(s3DeleteData);

    var sure = confirm("Are you sure,Do you want to delete?");
    if (sure == true) {
      this.dataService.deleteS3Object(s3DeleteData).subscribe((Data: any) => {
        var newData;
        if (typeof Data == "string") {
           newData = JSON.parse(Data);
        } else {  
           newData = Data;
        }
        console.log(newData);
        if (newData.Data.Deleted.length == 0) {
          // console.log(newData.Error.message);
          // alert(newData.Error.message);
          this.toastr.errorToastr("Error","oops!")
        } else if (newData.Status == "Success") {
          // alert("Object Deleted Successfully");
          this.toastr.successToastr("Object Deleted Successfully","Success!")
          location.reload(),1500;
        }
      });
    } else {
      console.log("Cancel");
    }
  }

  getSignedUrl(key) {
    this.router.navigate([
      "/getSignedUrl",
      { "bucketName": this.bucketName, "Key": key }
    ]);
  }
  getFileType(key) {
    // console.log(key)
    key = key.split(".");
    key = key[key.length - 1].toLowerCase()
    // console.log(key)
    if(key.match('/')){
      return "../../assets/icons/folder.png"; 
    }else {
    return "../../assets/icons/" + key + ".png";
    }
  }

  downloadS3Object(key){
    let fileName;
    if(key.lastIndexOf("/") >= 0){
      fileName = key.split("/")
    // console.log(key[key.length-1])
     fileName = fileName[fileName.length-1]
    //  console.log(fileName)
    }else {
      fileName = key;
    }
    let params = {"bucketName" : this.bucketName, "Key" : key, "fileName" : fileName, "obj": "getObject", "expireTime" : 60}
    this.dataService.getSignedUrl(params).subscribe((res:any) =>{
      if(typeof res == 'string'){
        res = JSON.parse(res)
      }
      console.log(res)
      if(res.Status == 'Success'){
        // alert(res.Data)
        console.log(res.Data)
        window.location.href = (res.Data);     
        this.toastr.infoToastr("Downloading","info")
        //location.reload();
      }
    });
  }

  uploads3Object(){
    console.log(this.bucketName)
    // localStorage.setItem("bucket",this.bucketName)
    const modalRef = this.modalService.open(UploadS3ObjectComponent);
     modalRef.componentInstance.name = this.bucketName;
     // modal.componentInstance.advertiser= this.bucketName;
   }

   gridView(){
     this.router.navigate(['/grid-object', {"bucketname" : this.bucketName,maxkey:500}])
   }
}
